const emailRule = [
  v => {
    return !!v || "Bitte E-Mail angeben";
  },
  v =>
    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,32})+$/.test(v) ||
    "E-Mail must be valid"
];

const requiredRule = [v => !!v || "Bitte ausfüllen"];

export { emailRule, requiredRule };
